export class PaymentMethod {
    last4: string;
    expMonth: string;
    expYear: string;
    brand: string;

    constructor(last4: string, expMonth: string, expYear: string, brand: string) {
        this.last4 = last4;
        this.expMonth = expMonth;
        this.expYear = expYear;
        this.brand = brand;
    }

    getExpiryString() {
        return `${('0' + this.expMonth).slice(-2)}/${this.expYear}`;
    }
}
